import { ObjectPropertyType } from "../ObjectPropertyType";
import { ObjectSchemaType } from "../ObjectSchemaType";
import { VariableScope } from './VariableScope';

export class SchemaTypeVariableScope extends VariableScope {
	readonly additionalProperties?: ObjectPropertyType;

	constructor(schemaType: ObjectSchemaType) {
		super(schemaType.properties.reduce((prev, property) => prev.set(property.name, property), new Map<string, ObjectPropertyType>()));
		this.additionalProperties = schemaType.additionalProperties;
	}

	getVariable(name: string): ObjectPropertyType | undefined {
		return super.getVariable(name) ?? (this.additionalProperties ? { ...this.additionalProperties, name } : undefined);
	}
}

